import { Outlet, createFileRoute } from '@tanstack/react-router'
import { ModuleGuard } from '@/components/module-guard'

export const Route = createFileRoute('/hr/employees')({
  component: EmployeesLayout,
})

function EmployeesLayout() {
  return (
    <ModuleGuard moduleKey="hr">
      <Outlet />
    </ModuleGuard>
  )
}
